import { render, staticRenderFns } from "./ChartOfAccountsTable.vue?vue&type=template&id=0b3b5fde&"
import script from "./ChartOfAccountsTable.vue?vue&type=script&lang=js&"
export * from "./ChartOfAccountsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports